function numberToTwoDigitString(input: number): string {
  const raw = input.toString();
  return raw.length < 2 ? `0${raw}` : raw;
}

export default numberToTwoDigitString;
